

export function VenueImageSection() {
    return (
        <section className="relative w-full overflow-hidden bg-bg-base">
            <div className="w-full relative">
                <img
                    src="/images/venue.png"
                    alt="The Wedding Venue"
                    className="w-full h-auto animate-fade-in"
                    width="2000"
                    height="1042"
                    loading="lazy"
                />
                {/* Subtle overlay to soften the image edges if needed */}
                <div className="absolute inset-0 shadow-[inset_0_0_100px_rgba(0,0,0,0.05)] pointer-events-none" />
            </div>
        </section>
    );
}
